<!--
 * @Author: Latte
 * @Date: 2021-08-02 09:00:08
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-27 16:07:28
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\diagnosisManagement\roleApplicationMgt\detail\index.vue
-->
<template>
	<div class="app-container">
		<el-card class="box-card">
			<el-form ref="form" :model="userDetail" label-width="140px">
				<el-row style="display: flex;">
					<el-col :span="10">
						<el-form-item label="会诊用户 ID:">
							<div>{{ userDetail.createUserID }}</div>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="审核状态:">
							<div>{{ userDetail.auditStatus | auditStatusTransform}}</div>
						</el-form-item>
					</el-col>

				</el-row>

				<el-row style="display: flex;">
					<el-col :span="10">
						<el-form-item label="审核时间:">
							<div>{{ userDetail.auditTime | formatDateTime }}</div>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="申请时间:">
							<div>{{ userDetail.createTime | formatDateTime }}</div>
						</el-form-item>
					</el-col>
				</el-row>

				<div class="scroll">
					<el-row>

						<el-col :span="10">
							<el-form-item label="申请人姓名:">
								<div>{{ userDetail.firstName }}{{userDetail.lastName}}</div>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="申请人身份证:">
								<div>{{ userDetail.idNumber }}</div>
							</el-form-item>
						</el-col>
					</el-row>



					<el-row>
						<el-col :span="10">
							<el-form-item label="申请角色:">
								<div>{{ userDetail.role | consultationRoleTransform }}</div>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="手机:">
								<div>{{ userDetail.mobilePhone }}</div>
							</el-form-item>
						</el-col>

					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="工作地点:">
								<div>{{ userDetail.fullWorkPlace }}</div>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="申请单位:">
								<div>{{ userDetail.company }}</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row style="align-items: center;display: flex;" align="center">
						<el-col class="pic" align="center">
							<el-image :key="userDetail.idReversePic" :src="config.RESOURCES+userDetail.idReversePic"
								fit="contain" :preview-src-list="getPicPre(entity)" :initial-index="0">
							</el-image>
							<p>身份证反面照片</p>
						</el-col>
						<el-col class="pic" align="center">
							<el-image :key="userDetail.idFrontPic" :src="config.RESOURCES+userDetail.idFrontPic"
								fit="contain" :preview-src-list="getPicPre(entity)" :initial-index="1">
							</el-image>
							<p>身份证正面照片</p>
						</el-col>
						<el-col class="pic" align="center">
							<el-image :key="userDetail.physicianLicence"
								:src="config.RESOURCES+userDetail.physicianLicence" fit="contain"
								:preview-src-list="getPicPre(entity)" :initial-index="2"></el-image>
							<p>医师资格证</p>
						</el-col>
					</el-row>

				</div>
				
				
				<el-row v-if="entity.auditStatus === 2" style="padding-top: 20px;">
					<el-form-item  label="拒绝原因：">
						<el-input v-model="userDetail.reason" type="textarea" rows="3" disabled />
					</el-form-item>

				</el-row>

				<el-row v-else style="padding-top: 20px;">
					<el-form-item label="用户服务:">
						<el-checkbox-group v-model="selectedUserServices">
							<el-checkbox v-for="item in userServices" :label="item.name" :key="item.id">{{item.name}}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-row>
				<el-row style="padding-top: 20px;display: flex;">
					<el-col align="center">
						<el-button type="success" @click="onAccept" :disabled="userDetail.auditStatus !== 0">通过
						</el-button>

					</el-col>
					<el-col align="center">
						<el-button type="warning" @click="onReject" :disabled="userDetail.auditStatus !== 0">驳回
						</el-button>

					</el-col>
					<el-col align="center">
						<el-button type="primary" :disabled="userDetail.auditStatus === 2">修改权限</el-button>
					</el-col>
				</el-row>

			</el-form>
		</el-card>
	</div>
</template>

<script>
	import {
		getConsultationUserService,
		updateRoleApplication,
	} from "@/api/system/diagnosisManagement/diagnosticRoleApplication"

	export default {
		emits: ['on-accept', 'on-reject'],
		methods: {

			/**
			 * @description: 初始化userDetail
			 * @param {*}
			 * @return {*}
			 */
			async initUserDetail() {
				this.userDetail = this.entity;
			},

			/**
			 * @param {Object} row
			 */
			getPicPre(entity) {
				return [
					this.config.RESOURCES + entity.idFrontPic,
					this.config.RESOURCES + entity.idReversePic,
					this.config.RESOURCES + entity.physicianLicence,
				]
			},

			// noticed() {
			//   const length = Object.keys(this.$route.params).length;
			//   console.log(length);
			//   if (length === 0 && this.goBackFlag !== 1) {
			//     console.log("innoticed");
			//     this.$message({
			//       message: "页面数据缺失，返回上一页",
			//       type: "error",
			//       showClose: true,
			//       duration: 2000,
			//     });
			//     this.goBack();
			//   }
			// },

			/**
			 * 点击通过，emit "on-accept" 事件
			 */
			onAccept() {
				this.$emit("on-accept")
			},
			/**
			 * 点击通过，emit "on-reject" 事件
			 */
			onReject() {
				this.$emit("on-reject")
			},
			async getUserService() {
				let res = await getConsultationUserService()
				this.userServices = res
			}
		},
		data() {
			return {
				userDetail: {},
				// goBackFlag: 0, // 返回键标记
				userServices: [],
				selectedUserServices: []
			};
		},

		created() {
			// window.addEventListener("beforeunload", this.noticed());
			console.log('----- created')
			this.initUserDetail();
			this.getUserService()
		},
		props: {
			entity: {
				type: Object,
				require
			},
		},

		// destroyed() {
		//   window.removeEventListener("beforeunload", this.noticed());
		// },
	};
</script>

<style scoped lang="scss">
	.pic {
		width: 30%;
		// height: 140px;
		margin: 20px;
	}

	.scroll {
		// height: 60vh;
		overflow: auto;
	}

	.app-container {
		height: 100%;
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}
</style>
